"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPublishFunction = void 0;
const functions_1 = require("firebase/functions");
const getPublishFunction = (functions) => (0, functions_1.httpsCallable)(functions || (0, functions_1.getFunctions)(), "setfan-publish");
exports.getPublishFunction = getPublishFunction;
//# sourceMappingURL=publish.js.map